import { getToken } from '@/utils/auth' // get token from cookie
import { cacheName, cache } from '@/utils/cacheManager'
import { changeSopState } from '@/api/booking/job'
import { Job } from '@/class/model/booking/Job'

export class PrintUtils {
  static instance
  static PRINT = 'print'
  static SAVE = 'save'
  static CANCEL = 'cancel'
  static EMAIL = 'email'
  static FAX = 'fax'
  constructor() {

  }

  /**
   * singleton
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new PrintUtils()
    }
    return this.instance
  }

  /**
   * @
   */
  static isExecutor(action) {
    if (action === this.PRINT || action === this.SAVE || action === this.EMAIL || action === this.FAX) {
      return true
    }
    return false
  }

  /**
   * @
   */
  static isPrint(action) {
    if (action === this.EMAIL || action === this.FAX) {
      return true
    }
    return false
  }

  /**
   * v1触发sop: 参照v2
   */
  static printChangeSop(template, documentType, entity) {
    setTimeout(function() { PrintUtils.printChangeSopState(template, documentType, entity) }, 3000)
  }

  static async printChangeSopState(template, documentType, entity) {
    await cache.load(cacheName.CONFIG)
    try {
      if (template === null || entity === null) {
        return
      }
      const sessionId = getToken()
      if (!sessionId || sessionId === 'null') {
        return
      }

      const _entity = this.converAbstractEntity(entity)
      // 打印回调URL
      // let printCallBackUrl = ''
      const jobKey = this.getJobKey(_entity)
      console.log('===printChangeSopState=jobKey==', jobKey)
      console.log('===printChangeSopState=_entity==', _entity)
      console.log('===printChangeSopState=documentType==', documentType)
      if (jobKey != null && documentType) {
        const serverUrl = cache.config.get('CargoApiURL')
        // v2默认【放在后端拼了】
        // printCallBackUrl = serverUrl + 'services/apiMove/cargo/v2/printExec/template/V2/printed/changeSopState?sessionId=' + sessionId + '&jobKey=' + encodeURIComponent(jobKey) + '&documentTypeKey=' + encodeURIComponent(documentType.uuid)
        // console.log('===printCallBackUrl===', printCallBackUrl)
        await this.navigateToURL(serverUrl, sessionId, encodeURIComponent(jobKey), encodeURIComponent(documentType.uuid))
      }
    } catch (error) {
      console.log('===printChangeSopState===', error.toString())
    }
  }

  /**
   * 调用后端触发sop,以免出现跨域问题
   * @param serverUrl
   * @param sessionId
   * @param jobKey
   * @param documentTypeKey
   * @returns {Promise<void>}
   */
  static async navigateToURL(serverUrl, sessionId, jobKey, documentTypeKey) {
    await changeSopState(serverUrl, sessionId, jobKey, documentTypeKey).then(res => {
      console.log('===changeSopState===', res.data)
    })
  }

  /**
   * 获取当前entity对象
   */
  static converAbstractEntity(entity) {
    return !entity ? null : entity
  }

  static getJobKey(entity) {
    if (entity) {
      // if (entity is Job)
      //   return entity.key;
      // else if (entity is CargoDoc)
      //   return CargoDoc(entity).job.key;
      // else if (entity is TruckingInfo)
      //   return TruckingInfo(entity).job.key;
      // else if (entity is WarehouseInfo)
      //   return WarehouseInfo(entity).job.key;
      // else if (entity is Charge)
      //   return Charge(entity).job.key;
      // else if ((entity is Billing) && Billing(entity).job)
      //   return Billing(entity).job.key
      if (Object.prototype.hasOwnProperty.call(entity, 'jobUuid')) {
        return entity.jobUuid
      } else if (entity.jobUuid) {
        return entity.jobUuid
      } else {
        return entity.uuid
      }
    }
    return null
  }
}
